module.exports = __webpack_public_path__ + "static/team4-80769bbee28e23512c30bf979232f286.jpg";